var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 335,
    viewBox: "0 0 123 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.767 274.491C122.767 307.666 95.2983 334.552 61.4332 334.552C27.5681 334.552 0.0976562 307.654 0.0976562 274.491C0.0976562 250.895 13.9931 230.476 34.2082 220.654V26.8789C34.1787 23.3596 34.8611 19.8693 36.216 16.6095C37.5709 13.3497 39.5715 10.3849 42.1025 7.88608C44.6334 5.38725 47.6445 3.40387 50.9621 2.05036C54.2798 0.696853 57.8382 0 61.4323 0C65.0263 0 68.5848 0.696853 71.9024 2.05036C75.22 3.40387 78.2311 5.38725 80.762 7.88608C83.293 10.3849 85.2936 13.3497 86.6485 16.6095C88.0035 19.8693 88.6859 23.3596 88.6564 26.8789V220.654C108.871 230.474 122.767 250.895 122.767 274.491Z",
    fill: "#CADDDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.989 274.486C110.989 301.28 88.8108 323 61.4466 323C34.0824 323 11.9043 301.28 11.9043 274.486C11.9043 254.401 24.3695 237.166 42.1381 229.796V180.356H80.7552V229.796C98.5237 237.166 110.989 254.401 110.989 274.486Z",
    fill: "#41A148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1348 180.358V27.4367C42.1348 22.4215 44.1693 17.6117 47.7907 14.0654C51.4121 10.5191 56.3237 8.52686 61.4452 8.52686C66.5666 8.52686 71.4783 10.5191 75.0997 14.0654C78.7211 17.6117 80.7556 22.4215 80.7556 27.4367V180.358H42.1348Z",
    fill: "#41A148"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7457 27.4398V180.361H69.0441V26.5521C69.0441 20.2614 65.5977 10.3752 53.1123 10.3752C56.0561 8.99748 59.3084 8.37267 62.5655 8.55907C65.8227 8.74546 68.9785 9.73699 71.7384 11.4411C74.4983 13.1452 76.7722 15.5063 78.348 18.304C79.9237 21.1017 80.7499 24.2447 80.7494 27.4398H80.7457Z",
    fill: "#41A148"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 30.9561H66.7471V32.8605H76.8244V30.9561Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 47.4819H66.7471V49.3864H76.8244V47.4819Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 35.0239H71.8652V35.9797H76.8151V35.0239Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 38.1382H71.8652V39.094H76.8151V38.1382Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 41.2524H71.8652V42.2082H76.8151V41.2524Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 44.3672H71.8652V45.323H76.8151V44.3672Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 64.0137H66.7471V65.9181H76.8244V64.0137Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 51.5439H71.8652V52.4998H76.8151V51.5439Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 54.6646H71.8652V55.6204H76.8151V54.6646Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 57.7896H71.8652V58.7454H76.8151V57.7896Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 60.9043H71.8652V61.8601H76.8151V60.9043Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 80.5503H66.7471V82.4547H76.8244V80.5503Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 68.0869H71.8652V69.0427H76.8151V68.0869Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 71.1958H71.8652V72.1516H76.8151V71.1958Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 74.3154H71.8652V75.2712H76.8151V74.3154Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 77.4307H71.8652V78.3865H76.8151V77.4307Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 97.0767H66.7471V98.9811H76.8244V97.0767Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 84.6128H71.8652V85.5686H76.8151V84.6128Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 87.7275H71.8652V88.6833H76.8151V87.7275Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 90.8477H71.8652V91.8035H76.8151V90.8477Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 93.9678H71.8652V94.9236H76.8151V93.9678Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 113.608H66.7471V115.513H76.8244V113.608Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 101.145H71.8652V102.1H76.8151V101.145Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 104.259H71.8652V105.215H76.8151V104.259Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 107.374H71.8652V108.33H76.8151V107.374Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 110.494H71.8652V111.45H76.8151V110.494Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 130.146H66.7471V132.05H76.8244V130.146Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 117.676H71.8652V118.632H76.8151V117.676Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 120.791H71.8652V121.746H76.8151V120.791Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 123.911H71.8652V124.866H76.8151V123.911Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 127.025H71.8652V127.981H76.8151V127.025Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 146.671H66.7471V148.576H76.8244V146.671Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 134.208H71.8652V135.164H76.8151V134.208Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 137.322H71.8652V138.278H76.8151V137.322Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 140.443H71.8652V141.399H76.8151V140.443Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 143.557H71.8652V144.513H76.8151V143.557Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 163.204H66.7471V165.108H76.8244V163.204Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 150.739H71.8652V151.695H76.8151V150.739Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 153.854H71.8652V154.81H76.8151V153.854Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 156.963H71.8652V157.919H76.8151V156.963Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 160.083H71.8652V161.039H76.8151V160.083Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 179.729H66.7471V181.634H76.8244V179.729Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 167.271H71.8652V168.227H76.8151V167.271Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 170.38H71.8652V171.336H76.8151V170.38Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 173.506H71.8652V174.462H76.8151V173.506Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 176.62H71.8652V177.576H76.8151V176.62Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 196.261H66.7471V198.165H76.8244V196.261Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 183.802H71.8652V184.758H76.8151V183.802Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 186.912H71.8652V187.867H76.8151V186.912Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 190.032H71.8652V190.988H76.8151V190.032Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 193.146H71.8652V194.102H76.8151V193.146Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8244 212.792H66.7471V214.697H76.8244V212.792Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 200.334H71.8652V201.29H76.8151V200.334Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 203.454H71.8652V204.41H76.8151V203.454Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 206.558H71.8652V207.514H76.8151V206.558Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8151 209.683H71.8652V210.639H76.8151V209.683Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.4341ad908b9716b3f4c8534721114e74.svg";
export { ForwardRef as ReactComponent };